import PropTypes from 'prop-types'
import React from 'react'
import clsx from 'clsx'
import * as dates from 'react-big-calendar/lib/utils/dates'
import { format, isEqual, differenceInMinutes } from 'date-fns'
import styled from 'styled-components'
import { DnDContext } from '../DnDContext'
import moment from 'moment-timezone'

const Container = styled.div`
    font-size: 0.8rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 100%;
    display: flex;
    flex-direction: ${props => props.orientation === 'vertical' ? 'column' : 'row'};
    padding: 0.1rem 0 0.2rem 0.2rem;
`

const TimeLabel = styled.div`
    margin-right: ${props => props.orientation === 'vertical' ? '0' : '0.5rem'};
`

class TimeEventCell extends React.Component {
    static contextType = DnDContext

    render() {
        let {
            event
        } = this.props
        
        // Get time label
        const localizer = this.context['extraProps']['localizer']
        const animate = this.context['extraProps']['animate']
        const a = localizer.format(event.start, 'h:mm')
        const b = localizer.format(event.end, 'h:mma')
        let timeLabel
        if(!isEqual(event.start, event.end)){
            timeLabel = `${a} - ${b}`
        } else {
            timeLabel = b
        }
        const duration = moment.isMoment(event.start) ? event.end.diff(event.start, 'minutes') : differenceInMinutes(event.end, event.start)
        const orientation = duration <= 10 ? 'horizontal' : 'vertical'

        return (
            <Container orientation={orientation} data-aos={animate && "fade-up"}>
                <TimeLabel orientation={orientation}>{timeLabel}</TimeLabel>
                {event.title}
            </Container>
        )
    }
}


export default TimeEventCell
